"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
import PropTypes from "prop-types";

import GreenCheck from "assets/svg/green-check-circle.svg";

import Button from "components/common/button";

import styles from "./styles.module.css";

const ModalCorporateSignupSuccess = () => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);

  const handleSuccessButton = () => {
    setIsLoading(true);
    router.push("/giris");
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.iconWrap}>
        <GreenCheck />
      </div>
      <h2 className={styles.title}>Talebinizi Aldık</h2>
      <p className={styles.content}>
        Kurumsal üyelik talebinizi aldık. Ekibimiz en kısa süre içerisinde sizinle iletişime geçecek.
      </p>
      <div className={styles.buttonWrapper}>
        <Button isLoading={isLoading} size={"M"} onClick={() => handleSuccessButton()}>
          Tamam
        </Button>
      </div>
    </div>
  );
};

ModalCorporateSignupSuccess.propTypes = {
  data: PropTypes.object,
};

export default ModalCorporateSignupSuccess;
